import * as React from 'react';
import styled from 'styled-components';
import Radio, { RadioProps } from '@material-ui/core/Radio';

import CircleChecked from '@material-ui/icons/CheckCircle';
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked';

const RadioButton = ({
  color = 'primary',
  size = 'small',
  ...props
}: RadioProps) => (
  <StyledRadio
    color={color}
    size={size}
    icon={<CircleUnchecked />}
    checkedIcon={<CircleChecked />}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);

const StyledRadio = styled(Radio)`
  padding: 6px;
  border-radius: var(--radius-full);
  transition: background-color var(--motion-fast)
    var(--ease-standard);

  &:hover {
    background-color: var(--primary-50);
  }

  &.Mui-focusVisible {
    box-shadow: var(--shadow-focus);
    background-color: var(--primary-50);
  }

  &.Mui-checked {
    color: var(--primary-600);
  }

  &.Mui-disabled {
    color: var(--neutral-300);
  }
`;

export default RadioButton;
